import { Directive, HostListener } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
@Directive({
  selector: '[trimFormInput]',
  providers: [NgModel],
  standalone: false
})
export class TrimFormInputDirective {
  constructor(private control: NgControl) {}

  @HostListener('blur')
  onBlur() {
    let value = this.control?.value;
    if (value) this.control.control.patchValue(value.trim());
    else this.control.control.patchValue(value);
    this.control.control.updateValueAndValidity();
  }
}
